import $ from "jquery";

const init = () =>{
    const buttonRegis = $(".el-content ");

    buttonRegis.on("click", function(){
        alert("Button click");
    });
}

init();